'use strict';
import angular from 'angular';

angular.module('clientServiceMapping.services', [])

    .factory('ClientMappingService', ['IORestangular', function(IORestangular) {
        var clientServiceAdv = IORestangular.all('/clientServiceAdvertisers/clientServiceAdvertiser');
        var cachedAdv = IORestangular.all('/clientServiceAdvertisers/cached');
        var externalAdvertisers = IORestangular.all('/cachedServiceAdvertisers');
        var pushServices = IORestangular.all('/serviceConnections/pushServices');
        var refreshCache = IORestangular.all('/externalAdvertisers/refreshCache');
        var cachedServiceAdvertiser = IORestangular.all('/cachedServiceAdvertisers/cachedServiceAdvertiser');

        var externalAdvertisersRefreshCache = function(paramObj) {
            return refreshCache.customPOST(paramObj, undefined, undefined, undefined);
        };

        var getExternalAdvertiserInfo = function(paramObj) {
            return cachedServiceAdvertiser.customGET(undefined, paramObj, undefined, undefined);
        };

        var getExternalAdvertisers = function(paramObj) {
            return externalAdvertisers.customGET(undefined, paramObj, undefined, undefined);
        };

        var getClientServiceAdvertiser = function(paramObj) {
            return clientServiceAdv.customGET(undefined, paramObj, undefined, undefined);
        };

        var getCachedAdvertiser = function(paramObj) {
            return cachedAdv.customGET(undefined, paramObj, undefined, undefined);
        };

        var addClientServiceAdvertiser = function(obj) {
            return clientServiceAdv.customPOST(obj, undefined, undefined, undefined);
        }

        var updateClientServiceAdvertiser = function(obj) {
            return clientServiceAdv.customPUT(undefined, undefined, obj, undefined);
        }

        var getPushServices = function(paramObj){
            return pushServices.customGET(undefined, paramObj, undefined, undefined);
        }

        return {
            externalAdvertisersRefreshCache:externalAdvertisersRefreshCache,
            getExternalAdvertiserInfo:getExternalAdvertiserInfo,
            getExternalAdvertisers:getExternalAdvertisers,
            getClientServiceAdvertiser: getClientServiceAdvertiser,
            addClientServiceAdvertiser: addClientServiceAdvertiser,
            updateClientServiceAdvertiser: updateClientServiceAdvertiser,
            getCachedAdvertiser: getCachedAdvertiser,
            getPushServices: getPushServices
        }

    }]);